(function () {
  angular
    .module('kareo.ui.shared.directives.k-spinner', [
      'kareo.ui.shared.directives.templates'
    ])
    .component('kSpinner', {
      bindings: {
        message: '@?', // Default: "Loading", hide by passing empty string
        while: '<'
      },
      controllerAs: 'vm',
      template: require('./k-spinner.pug')()
    });
})();
